const SuccessMessage = ({ message }: { message: string }) => {
  return (
    <div className="bg-[rgba(0,132,24,0.2)] rounded-[8px] h-[48px] mb-3x flex items-center p-1.5x">
      <p className="text-green_dark">{message}</p>
    </div>
  );
};

export default SuccessMessage;
